import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Dashboard, {
  isVisible: () => true,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Dashboard,
    title: 'Dashboard',
    url: '/app/aanvraag/recente-activiteiten/',
    iconclass: 'fa-solid fa-house-window',
    target: '_top',
  }),
});
